export const MODE = import.meta.env.VITE_MODE;
export const IS_PRODUCTION = MODE === 'prod';
export const API_URL = import.meta.env.VITE_API_URL;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'development';
export const CHECK_SCANNER_URL = import.meta.env.VITE_CHECK_SCANNER_URL;
export const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;
export const DATATDOG_BROWSER_LOGS_KEY = 'pub8d4801a9177aaabc76f12049aff19e16';
export const DATADOG_RUM_APPLICATION_ID = import.meta.env.VITE_DATADOG_RUM_APPLICATION_ID;
export const DATADOG_RUM_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID;
export const GOOGLE_RECAPTCHA_SITE_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY;
export const GOOGLE_RECAPTCHA_SITE_KEY_OLD = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY_OLD;
export const LAUNCH_DARKLY_CLIENT_ID = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID;
export const HOST = import.meta.env.VITE_HOST;
